/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchRunResultOperationPeriod } from './BatchRunResultOperationPeriod';
import {
    BatchRunResultOperationPeriodFromJSON,
    BatchRunResultOperationPeriodFromJSONTyped,
    BatchRunResultOperationPeriodToJSON,
    BatchRunResultOperationPeriodToJSONTyped,
} from './BatchRunResultOperationPeriod';

/**
 * operation（issue_date × start_date × end_date × service_category）を表す。
 * @export
 * @interface BatchRunResultOperation
 */
export interface BatchRunResultOperation {
    /**
     * operations API の operation_id と同一
     * @type {string}
     * @memberof BatchRunResultOperation
     */
    operationId: string;
    /**
     * 
     * @type {Date}
     * @memberof BatchRunResultOperation
     */
    issueDate: Date;
    /**
     * サービスカテゴリ（RunBatchRequest.service_category と同値）
     * @type {number}
     * @memberof BatchRunResultOperation
     */
    serviceCategory: number;
    /**
     * 
     * @type {BatchRunResultOperationPeriod}
     * @memberof BatchRunResultOperation
     */
    period: BatchRunResultOperationPeriod;
    /**
     * 業務処理ステータス（文字列）。
     * operations API の ProcessStatus（int）と同じ状態を表す。
     * 
     * @type {string}
     * @memberof BatchRunResultOperation
     */
    status: BatchRunResultOperationStatusEnum;
}


/**
 * @export
 */
export const BatchRunResultOperationStatusEnum = {
    CompletedAggregated: 'COMPLETED_AGGREGATED',
    Failed: 'FAILED',
    CompletedPublished: 'COMPLETED_PUBLISHED',
    CompletedDetailPublished: 'COMPLETED_DETAIL_PUBLISHED',
    Running: 'RUNNING'
} as const;
export type BatchRunResultOperationStatusEnum = typeof BatchRunResultOperationStatusEnum[keyof typeof BatchRunResultOperationStatusEnum];


/**
 * Check if a given object implements the BatchRunResultOperation interface.
 */
export function instanceOfBatchRunResultOperation(value: object): value is BatchRunResultOperation {
    if (!('operationId' in value) || value['operationId'] === undefined) return false;
    if (!('issueDate' in value) || value['issueDate'] === undefined) return false;
    if (!('serviceCategory' in value) || value['serviceCategory'] === undefined) return false;
    if (!('period' in value) || value['period'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function BatchRunResultOperationFromJSON(json: any): BatchRunResultOperation {
    return BatchRunResultOperationFromJSONTyped(json, false);
}

export function BatchRunResultOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchRunResultOperation {
    if (json == null) {
        return json;
    }
    return {
        
        'operationId': json['operation_id'],
        'issueDate': (new Date(json['issue_date'])),
        'serviceCategory': json['service_category'],
        'period': BatchRunResultOperationPeriodFromJSON(json['period']),
        'status': json['status'],
    };
}

export function BatchRunResultOperationToJSON(json: any): BatchRunResultOperation {
    return BatchRunResultOperationToJSONTyped(json, false);
}

export function BatchRunResultOperationToJSONTyped(value?: BatchRunResultOperation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operation_id': value['operationId'],
        'issue_date': ((value['issueDate']).toISOString().substring(0,10)),
        'service_category': value['serviceCategory'],
        'period': BatchRunResultOperationPeriodToJSON(value['period']),
        'status': value['status'],
    };
}

